'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import { assetUrl } from '../../utils/asset';
import type { AvatarProps } from './Avatar.types';
import DefaultThumbnailAsset from './images/default-thumbnail.png';
import { Status } from './layout/Status';

import styles from './Avatar.module.scss';

const DefaultThumbnail = assetUrl(DefaultThumbnailAsset);

export function Avatar({
  style,
  className,
  src = DefaultThumbnail,
  status,
  statusPosition = 'bottom',
  size = 'md',
  rounded = false,
  alt = '',
  testId = 'ui-avatar',
  ref,
  ...rest
}: AvatarProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(styles['avatar'], className)}
      data-testid={testId}
      {...rest}
    >
      {status && (
        <Status
          status={status}
          size={size}
          className={classnames(
            styles['status'],
            status && styles[`status--${statusPosition}`],
          )}
        />
      )}
      <img
        className={classnames(
          styles['thumbnail'],
          size && styles[`thumbnail--${size}`],
          rounded && styles[`thumbnail--rounded`],
          status && styles[`crop--${statusPosition}`],
        )}
        alt={alt}
        src={src}
      />
    </div>
  );
}
